import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-prev",
  "use": "icon-prev-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-prev\">\n   \n        <polyline id=\"icon-prev_Stroke-1-Copy-6\" stroke-width=\"2\" transform=\"translate(12.000000, 11.589775) scale(1, -1) translate(-12.000000, -11.589775) \" points=\"24 5.76 18.0002078 11.5899135 11.9998614 17.4195499 6.00006928 11.5899135 0 5.76\" />\n  \n</symbol>"
});
var result = sprite.add(symbol);
export default symbol